/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from 'react';
import * as API from '../../http/api';
import { useHistory } from 'react-router-dom';
import { Button, Grid, FormControl, IconButton, InputLabel, Tab, Tabs, Tooltip, Typography, Select, MenuItem, Dialog, DialogTitle, DialogContent, TextField, Chip, Box, DialogActions, Checkbox, FormControlLabel, FormGroup, Switch, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { Edit, AddCircle, Search, Close, ExpandMore, AllInclusive } from '@mui/icons-material';
import { theme, customStyles } from '../../util/TableStyles';
import { noDataComponent } from "../../util/DataObject";
import { ThemeProvider } from '@mui/material/styles';
import { Card, FlexGrid } from '@albo-ui/core'
import { ModalStyle } from '../../util/Styles';
import DataTable from 'react-data-table-component';
import moment from 'moment';
import 'moment/locale/es';

const Management = (props) => {
    moment.locale('es');
    const [list, setList] = useState([]);
    const [total, setTotal] = useState(0);
    const [limit, setLimit] = useState(5);
    const [page, setPage] = useState(1);
    const [type, setType] = useState('gateway');
    const [apps, setApps] = useState([]);
    const [domainsConfig, setDomainsConfig] = useState([]);
    const [modal, setModal] = useState(false);
    const [update, setUpdate] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [checked, setChecked] = useState(true);
    const [zPos, setZPos] = useState(45)
    
    const [contentModal, setContentModal] = useState({title: '', id: '', gateway_uri: '', endpoint: '', domain: '', apps: [], topic: '', subscriptions: []});
    const [formGateway, setFormGateway] = useState({id: '', gateway_uri: '', endpoint: '', domain: '', apps: []});
    const formSidecar = { id: '', topic: '', subscriptions: []}
    const [filtersGateway, setFiltersGateway] = useState({gateway_uri: '', endpoint: '', app: '', domain: ''});
    const [filtersSidecar, setFiltersSidecar] = useState({ topic: '', deadletter_topic: '', endpoint: '', name: '', domain: ''});

    const history = useHistory();

    const tabs = [
        { label: 'Gateway manager', value: 'gateway', checked: false },
        { label: 'Gateway manager drp', value: 'gateway_drp', checked: false },
        { label: 'Sidecar manager', value: 'sidecar', checked: false },
        { label: 'Sidecar manager drp', value: 'sidecar_drp', checked: false }
    ]

    useEffect(() => {
        init();
    }, [props.content]);

    const paginationComponentOptions = {
		rangeSeparatorText: 'de',
		rowsPerPageText: 'Registros por página',
	};

    const addSubscription = () => {
        let c = contentModal;
        let sub = {
            domain: '',
            name: '',
            endpoint: '',
            batchSize:  '',
            ackTimeoutSeconds:  '',
            retryLimit:  '',
            deadletter_topic: '',
            retryDelaySeconds:  ''
        }

        c.subscriptions.push(sub);
        setContentModal(JSON.parse(JSON.stringify(c)));
        setDisabled(true);
    }

    const changePage = async (value) => {
		let data = {
			page: value,
			limit: limit,
            type: type
		}
        let dataSearch = validateDataSearch()
        if(dataSearch){
            data = Object.assign(data, dataSearch)
        }
		//setPage(p);
		await reloadData(data);
	};

    const init = () => {
        setApps([]);
        let dataFilterGateway = {
            gateway_uri: '',
            endpoint: '',
            app: '',
            domain: '',
        }

        let dataFilterSidecar = {
            topic: '',
            deadletter_topic: '',
            endpoint: '',
            name: '',
            domain: ''
        }
        if(props.content.limit){
            setLimit(props.content.limit);
        }
        if(props.content.page){
            setPage(props.content.page);
        }
        if(props.content.total){
            setTotal(props.content.total);
        }
        if(props.content.type){
            setType(props.content.type);
            if(props.content.type == 'gateway' || props.content.type == 'gateway_drp'){
                if(props.content.app){
                    dataFilterGateway['app'] = props.content.app;
                }
                if(props.content.endpoint){
                    dataFilterGateway['endpoint'] = props.content.endpoint;
                }
                if(props.content.gateway_uri){
                    dataFilterGateway['gateway_uri'] = props.content.gateway_uri;
                }
                if(props.content.domain){
                    dataFilterGateway['domain'] = props.content.domain;
                }
            }

            if(props.content.type == 'sidecar' || props.content.type == 'sidecar_drp'){
                if(props.content.topic){
                    dataFilterSidecar['topic'] = props.content.topic;
                }
                if(props.content.deadletter_topic){
                    dataFilterSidecar['deadletter_topic'] = props.content.deadletter_topic;
                }
                if(props.content.endpoint){
                    dataFilterSidecar['endpoint'] = props.content.endpoint;
                }
                if(props.content.name){
                    dataFilterSidecar['name'] = props.content.name;
                }
                if(props.content.domain){
                    dataFilterSidecar['domain'] = props.content.domain;
                }
            }
        }
        if(props.content.list){
            setList(JSON.parse(JSON.stringify(props.content.list)));
        }
        if(props.content.apps){
            setApps(JSON.parse(JSON.stringify(props.content.apps)));
        }
        if(props.content.domains_config){
            setDomainsConfig(JSON.parse(JSON.stringify(props.content.domains_config)));
        }

        setFiltersGateway(JSON.parse(JSON.stringify(dataFilterGateway)));
        setFiltersSidecar(JSON.parse(JSON.stringify(dataFilterSidecar)));
    }

    const changeTab = async (e, value) => {
        setType(value);
        await reloadData({
            type: value
        });
        //await requestReport({type: value});
    }

    const reloadData = async (data) => {
        props.changeLoader(true);
        let request = await API.service('initManagement', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200 && request.data.data.response == 'OK') {
            props.changeWidgets(JSON.parse(JSON.stringify(request.data.data.widget)));
        }
    
        props.changeLoader(false);
    };

    const validateDataSearch = () => {
        let data = {}

        if(filtersGateway.app){
            data['app'] = filtersGateway.app;
        }
        if(filtersGateway.gateway_uri){
            data['gateway_uri'] = filtersGateway.gateway_uri;
        }
        if(filtersGateway.endpoint){
            data['endpoint'] = filtersGateway.endpoint;
        }
        if(filtersGateway.domain){
            data['domain'] = filtersGateway.domain;
        }

        if(filtersSidecar.domain){
            data['domain'] = filtersSidecar.domain;
        }
        if(filtersSidecar.topic){
            data['topic'] = filtersSidecar.topic;
        }
        if(filtersSidecar.endpoint){
            data['endpoint'] = filtersSidecar.endpoint;
        }
        if(filtersSidecar.name){
            data['name'] = filtersSidecar.name;
        }
        return data
    }
    const changeTotal = async (e) => {
		let data = {
			page: 1,
			limit: e,
            type: type
		}

        let dataSearch = validateDataSearch()
        if(dataSearch){
            data = Object.assign(data, dataSearch)
        }
		await reloadData(data);
	};

    const convertApps = (array) => {
        let a = [];
        for(let i = 0; i<array.length; i++){
            a.push(array[i]['app']);
        }
        return a;
    }
    const blockUnblock = async (uuid, e) => {
        let dataSend = { 
            type: type,
            action: 'edit',
            body: {
                id: uuid,
                active: e.target.checked
            }
        }

        await sendRequest(dataSend, 'createEditManagement', 'blockUnblock');
    }

    const colsSidecar = [
        { selector: (row) => row.topic, name: 'Topic', width: '35%', wrap: true, sortable: true },
        { selector: (row) => (row.cdate) ? moment(new Date(row.cdate)).format('L') : 'N/A', name: 'F. Creación', width: '15%', wrap: true, sortable: true },
        { selector: (row) => (row.udate) ? moment(new Date(row.udate)).format('L') : 'N/A', name: 'F. Actualización', width: '15%', wrap: true, sortable: true },
        { selector: (row) => (row.subscriptions) ? row.subscriptions.length : 0, name: 'Suscripciones', width: '15%', wrap: true, sortable: true, center: true },
        { cell: (row) => {
				return (
                    <Typography fontWeight="400" fontFamily="Muli,sans-serif" color="#000000de" fontSize="0.875rem">
                        <Tooltip title="Editar">
                            <IconButton onClick={openModal.bind(this, true, {
                                title: 'Editar dominio sidecar',
                                id: row._id,
                                topic: row.topic,
                                subscriptions: row.subscriptions,
                                gateway_uri: '',
                                endpoint: '',
                                domain: '',
                                apps: [],
                            }, true)}>
                                <Edit/>
                            </IconButton>
                        </Tooltip>
                    </Typography>
                )
			}, name: 'Editar', width: '10%'
		}
    ];

    const colsGateway = [
        { selector: (row) => (row.metadata) ? row.metadata.domain : 'N/A', name: 'Dominio', width: '11%', wrap: true, sortable: true },
        { selector: (row) => (row.metadata) ? row.metadata.gateway_uri : 'N/A', name: 'URI', width: '22%', wrap: true, sortable: true },
        { selector: (row) => (row.cdate) ? moment(new Date(row.cdate)).format('L') : 'N/A', name: 'Fecha', width: '12%', wrap: true, sortable: true },
        { selector: (row) => (row.metadata) ? row.metadata.endpoint : 'N/A', name: 'Endpoint', width: '30%', wrap: true, sortable: true },
        { cell: (row) => {
				return <FormGroup>
                    <FormControlLabel
                        control={<Switch checked={row.active ? row.active : false} onChange={blockUnblock.bind(this, row._id)}/>}
                        label={row.active ? 'Activo' : 'Inactivo'}
                    />  
				</FormGroup>
			}, name: 'Estatus', width: '14%'
		},
        { cell: (row) => {
				return <Typography fontWeight="400" fontFamily="Muli,sans-serif" color="#000000de" fontSize="0.875rem">
					<Tooltip title="Editar">
                        <IconButton onClick={openModal.bind(this, true, {
                            title: 'Editar dominio gateway',
                            id: row._id,
                            gateway_uri: row.metadata ? row.metadata.gateway_uri : '',
                            endpoint: row.metadata ? row.metadata.endpoint : '',
                            domain: row.metadata ? row.metadata.domain : '',
                            apps: convertApps(row.metadata && row.metadata.apps ? row.metadata.apps : []),
                            topic: '',
                            subscriptions: []
                        }, true)}>
                            <Edit/>
                        </IconButton>
                    </Tooltip>
				</Typography>
			}, name: 'Acciones', width: '10%'
		}
    ];

    const changeValueGateway = async (field, e) => {
        let gateway = filtersGateway;
        gateway[field] = e.target.value;
        setFiltersGateway(JSON.parse(JSON.stringify(gateway)));
        if(field == 'app'){
            let data = {
                page: 1,
                limit: limit,
                type: type
            }

            data['app'] = e.target.value;
            if(filtersGateway.gateway_uri){
                data['gateway_uri'] = filtersGateway.gateway_uri;
            }
            if(filtersGateway.endpoint){
                data['endpoint'] = filtersGateway.endpoint;
            }
            if(filtersGateway.domain){
                data['domain'] = filtersGateway.domain;
            }
            
            await reloadData(data);
        }
    }

    const changeValueSidecar = async (field, e) => {
        let sidecar = filtersSidecar;
        sidecar[field] = e.target.value;
        setFiltersGateway(JSON.parse(JSON.stringify(sidecar)));
        if(field == 'domain'){
            let data = {
                page: 1,
                limit: limit,
                type: type
            }

            data['domain'] = e.target.value;
            if(filtersSidecar.topic){
                data['topic'] = filtersSidecar.topic;
            }
            if(filtersSidecar.deadletter_topic){
                data['deadletter_topic'] = filtersSidecar.deadletter_topic;
            }
            if(filtersSidecar.name){
                data['name'] = filtersSidecar.name;
            }
            if(filtersSidecar.endpoint){
                data['endpoint'] = filtersSidecar.endpoint;
            }
            
            await reloadData(data);
        }
    }

    const validateDataGateway = (data) => {
        if(data.gateway_uri && data.endpoint && data.domain){
            setDisabled(false);
        }else{
            setDisabled(true);
        }
    }

    const validateDataSidecar = (data) => {
        if(data.topic && data.subscriptions.length > 0){
            //setDisabled(false);
            let names = [];
            for(let i = 0; i<data.subscriptions.length; i++){
                let sub = data.subscriptions[i];

                if(sub['name'] && sub['endpoint'] && sub['batchSize'] && sub['ackTimeoutSeconds'] && sub['domain'] && sub['retryLimit']){
                    if(names.indexOf(sub['name']) > -1){
                        setDisabled(true);
                    }else{
                        setDisabled(false);
                    }
                    names.push(sub['name']);
                }else{
                    if(sub['name'] && sub['endpoint'] && sub['batchSize'] && sub['ackTimeoutSeconds'] && sub['domain'] ){
                        if(names.indexOf(sub['name']) > -1){
                            setDisabled(true);
                        }else{
                            setDisabled(false);
                        }
                        names.push(sub['name']);
                    }else{
                        setDisabled(true);
                    }
                }
            }
        }else{
            setDisabled(true);
        }
    }

    const findFilters = async () => {
        let data = {
            type: type
		}

        if(filtersGateway.app){
            data['app'] = filtersGateway.app;
        }
        if(filtersGateway.gateway_uri){
            data['gateway_uri'] = filtersGateway.gateway_uri;
        }
        if(filtersGateway.endpoint){
            data['endpoint'] = filtersGateway.endpoint;
        }
        if(filtersGateway.domain){
            data['domain'] = filtersGateway.domain;
        }

        if(filtersSidecar.domain){
            data['domain'] = filtersSidecar.domain;
        }
        if(filtersSidecar.topic){
            data['topic'] = filtersSidecar.topic;
        }
        if(filtersSidecar.endpoint){
            data['endpoint'] = filtersSidecar.endpoint;
        }
        if(filtersSidecar.name){
            data['name'] = filtersSidecar.name;
        }
		await reloadData(data);
    }

    const openModal = (flag, data, edit) => {
        setModal(flag);
        setUpdate(edit);
        if(type == 'sidecar' || type == 'sidecar_drp'){
            for(let i = 0; i<data.subscriptions.length; i++){
                if(data.subscriptions[i]['deadLetterPolicy']){
                    data.subscriptions[i]['retryLimit'] = data.subscriptions[i]['deadLetterPolicy']['retryLimit'];
                    data.subscriptions[i]['deadletter_topic'] = data.subscriptions[i]['deadLetterPolicy']['topic'];
                }
                if(data.subscriptions[i]['retryPolicy']){
                    data.subscriptions[i]['retryDelaySeconds'] = data.subscriptions[i]['retryPolicy']['retryDelaySeconds'];
                }
            }
        }
        setContentModal(JSON.parse(JSON.stringify(data)));
    }

    const changeValueModal = (field, e) => {
        let m = contentModal;
        m[field] = e.target.value;
        if(type == 'gateway' || type == 'gateway_drp'){
            validateDataGateway(m);
        }

        if(type == 'sidecar' || type == 'sidecar_drp'){
            validateDataSidecar(m);
        }
        setContentModal(JSON.parse(JSON.stringify(m)));
    }

    const createEdit = async () => {
        let form = {};
        let data = contentModal;
        if(type == 'gateway' || type == 'gateway_drp'){
            form = formGateway;
            form['id'] = data.id;
            form['gateway_uri'] = data.gateway_uri;
            form['domain'] = data.domain;
            form['apps'] = data.apps;
            form['endpoint'] = data.endpoint;

            if(type == 'gateway_drp'){
                form['drp'] = true;
            }else{
                if(form['id']){
                    delete form['drp'];
                }else{
                    if(checked){
                        form['drp'] = true;
                    }else{
                        delete form['drp'];
                    }
                }
            }
        }

        if(type == 'sidecar' || type == 'sidecar_drp'){
            form = formSidecar;
            form['id'] = data.id;
            form['topic'] = data.topic;
            form['subscriptions'] = data.subscriptions;

            for(let i = 0; i<form['subscriptions'].length; i++){
                if(!form['subscriptions'][i]['deadletter_topic']){
                    delete form['subscriptions'][i]['deadletter_topic'];
                }

                if(!form['subscriptions'][i]['retryLimit']){
                    delete form['subscriptions'][i]['retryLimit'];
                }

                if(!form['subscriptions'][i]['retryDelaySeconds']){
                    delete form['subscriptions'][i]['retryDelaySeconds'];
                }
            }

            if(type == 'sidecar_drp'){
                form['drp'] = true;
            }else{
                if(form['id']){
                    delete form['drp'];
                }else{
                    if(checked){
                        form['drp'] = true;
                    }else{
                        delete form['drp'];
                    }
                }
            }
        }

        let dataSend = {
            type: type,
            action: contentModal.id ? 'edit' : 'create',
            body: form
        }

        await sendRequest(dataSend, 'createEditManagement');
    }

    const sendRequest = async (data, action, reopen='') => {
        props.changeLoader(true);
        setZPos(-1)

        let request = await API.service(action, data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200 && request.data.data.response == 'OK') {
            openModal(false, {
                title: '',
                id: '',
                gateway_uri: '',
                endpoint: '',
                domain: '',
                apps: [],
                topic: '',
                subscriptions: []
            }, false);
            props.changeAlert(true, 'success', request.data.data.message);
            await reloadData({type: type, page: page, limit: limit});
            setDisabled(true);
        }else{
            props.changeAlert(true, "error", `Error al ${contentModal['title'].toLowerCase()}: ${request.data.data.message}`);
        }
        props.changeLoader(false);
        setZPos(45)
    }

    const changeCheck = (e) => {
        setChecked(e.target.checked);
    }

    const subsLabel = (name, value) => {
        return <Grid item container xs={12}>
            <Grid item xs={2}>
                <Typography component={'label'} fontFamily="Muli,sans-serif" fontSize="14px" sx={{color: '#969BA0', }}>
                    {name}
                </Typography>
            </Grid>
            <Grid item xs={10}>
                <Typography component={'p'} fontFamily="Muli,sans-serif" fontSize="14px" sx={{color: '#3E3E42', }}>
                    {value}
                </Typography>
            </Grid>
        </Grid>
    }
 
    const Subscriptions = (data) => {
        let subs = data.data.subscriptions;
        return <div>
            {
                subs && subs.map((item, index) => {
                    return <Accordion key={`accordion-${index}`}>
                        <AccordionSummary
                            expandIcon={<ExpandMore/>}
                            id='panels'
                        >
                            <Typography fontWeight="600" fontFamily="Muli,sans-serif" color="#3E3E42" fontSize="0.875rem" component={'span'}>
                                {item['name']}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container spacing={1}>
                                {subsLabel('Dominio', item['domain'])}
                                {subsLabel('Endpoint', item['endpoint'])}
                                {subsLabel('Tiempo de espera', item['ackTimeoutSeconds'] ? item['ackTimeoutSeconds'] + ' Segundos' : 'N/A')}
                                {subsLabel('Tiempo de reintento', item['retryPolicy'] && item['retryPolicy']['retryDelaySeconds'] ? item['retryPolicy']['retryDelaySeconds'] + ' Segundos' : 'N/A')}
           
                                {
                                    item['deadLetterPolicy'] && 
                                    <>
                                        {subsLabel('Deadletter Topic', item['deadLetterPolicy'] && item['deadLetterPolicy']['topic'] ? item['deadLetterPolicy']['topic'] : 'N/A')}
                                        {subsLabel('Reintentos', item['deadLetterPolicy'] && item['deadLetterPolicy']['retryLimit'] ? item['deadLetterPolicy']['retryLimit'] : 'N/A')}
                                    </>
                                }
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                })
            }
        </div>
    }

    const changeValueSubs = (field, index, e) => {
        let c = contentModal;
        if(field === 'batchSize' || field === 'ackTimeoutSeconds' || field === 'retryDelaySeconds' || field === 'retryLimit'){
            c.subscriptions[index][field] = Number(e.target.value);
        } else {
            c.subscriptions[index][field] = e.target.value;
        }
        validateDataSidecar(c);
        setContentModal(JSON.parse(JSON.stringify(c)));
    }

    const deleteSubscription = (index) => {
        let c = contentModal;
        let subs = [];
        for(let i = 0; i<c.subscriptions.length; i++){
            if(i != index){
                subs.push(c.subscriptions[i]);
            }
        }
        c.subscriptions = subs;
        setContentModal(JSON.parse(JSON.stringify(c)));
    }

    const inputSearch = (name, value, flag, array?) => {
        return <Grid item  width={"19%"}>
            {!array ?
                <TextField
                    label={name}
                    value={flag ? filtersGateway[value] : filtersSidecar[value]} onChange={flag ? changeValueGateway.bind(this, value) : changeValueSidecar.bind(this, value)} color="secondary" size="small" fullWidth
                    InputProps={{endAdornment: (<IconButton onClick={findFilters.bind(this)}><Search/></IconButton>)}}
                />
                :
                <TextField value={flag ? filtersGateway[value] : filtersSidecar[value]} label={name} onChange={flag ? changeValueGateway.bind(this, value) : changeValueSidecar.bind(this, value)} select size="small" fullWidth color="secondary">
                    <MenuItem value={-1} disabled>Seleccione</MenuItem>
                    <MenuItem value="">Todos</MenuItem>
                    {array?.map((item, index) => (
                        <MenuItem value={flag ? item.name : item.domain} key={`value-${index}`}>{flag ? item.name : item.domain}</MenuItem>
                    ))}
                </TextField>               
            }
        </Grid>
    }

    return (
        <Grid container >
            <Card padding={4} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" >
                <FlexGrid container fullWidth justify="space-between" >
                    <FlexGrid item>
                        <Typography variant="h2" fontWeight={600} fontFamily="Muli,sans-serif" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}}>
                            <AllInclusive sx={{ marginRight: 2, padding: "4px 8px", borderRadius: 2, boxSizing: "content-box", color: "white", backgroundColor: "#3743aa" }}/> Administrador Gateway-Sidecar
                        </Typography>
                    </FlexGrid>
                    <FlexGrid item>
                        <Tooltip title={(type == 'gateway' || type == 'gateway_drp') ? 'Crear dominio gateway' : 'Crear dominio sidecar'}>
                            <IconButton onClick={openModal.bind(this, true, {
                                    title: (type == 'gateway' || type == 'gateway_drp') ? 'Crear dominio gateway' : 'Crear dominio sidecar',
                                    id: '', gateway_uri: '', endpoint: '', domain: '', apps: [], subscriptions: [], topic: ''
                                }, false)} sx={{paddingTop: "0 !important"}}>
                                <AddCircle />
                            </IconButton>
                        </Tooltip>
                    </FlexGrid>
                </FlexGrid>

                <FlexGrid container spacing={2} style={{margin: '25px 0' }}>
                {
                    (type == 'gateway' || type == 'gateway_drp') &&
                    <Grid container item xs={12} spacing={2}>
                        {inputSearch('Endpoint', 'endpoint', true)}
                        {inputSearch('Gateway URI', 'gateway_uri', true)}
                        {inputSearch('App', 'app', true, apps)}
                        {inputSearch('Dominio', 'domain', true)}
                    </Grid>
                }
                {
                    (type == 'sidecar' || type == 'sidecar_drp') &&
                    <Grid container item xs={12} spacing={2}>
                        {inputSearch('Endpoint', 'endpoint', false)}
                        {inputSearch('Topic', 'topic', false)}
                        {inputSearch('Deadletter topic', 'deadletter_topic', false)}
                        {inputSearch('Dominio', 'domain', false, domainsConfig)}
                        {inputSearch('Nombre', 'name', false)}
                    </Grid>
                }
                </FlexGrid>
                <hr/>

                <FlexGrid container>
                    <Tabs value={type} sx={{width: '100%', paddingBottom: 4}} variant='fullWidth' indicatorColor='secondary' textColor='secondary' onChange={changeTab} >
                        {
                            tabs.map((item, index) => {
                                return <Tab label={
                                    <Typography component={'span'}  fontFamily="Muli,sans-serif" fontSize="13px" fontWeight={600} sx={{textTransform: 'none'}} >
                                        {item.label}
                                    </Typography>
                                } value={item.value} key={`tab-${index}`}/>
                            })
                        }
                    </Tabs>
                </FlexGrid>
                <ThemeProvider theme={theme} >
                    <DataTable
                        columns={(type == 'gateway' || type == 'gateway_drp') ? colsGateway : colsSidecar} 
                        data={list}
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                        pagination
                        paginationServer
                        paginationTotalRows={total}
                        onChangePage={changePage}
                        paginationPerPage={props.content.limit}
                        paginationRowsPerPageOptions={[5,10,20,30,40,50]}
                        onChangeRowsPerPage={changeTotal}
                        noDataComponent={noDataComponent}
                        expandableRows={(type == 'sidecar' || type == 'sidecar_drp') ? true : false}
                        expandableRowsComponent={Subscriptions}
                    />
                </ThemeProvider>
            </Card>

            {/* Modal cambiar --------------------------------------- */}
            <Dialog open={modal} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
                <ModalStyle property={String(disabled)}>
                    <DialogTitle>
                        {contentModal['title']}
                        <IconButton id="headButton"  onClick={openModal.bind(this, false, {title: '', id: '', gateway_uri: '', endpoint: '', domain: '', apps: [], topic: '', subscriptions: [] }, false)}><Close/></IconButton>
                    </DialogTitle>
                    <DialogContent>
                        {
                            (type == 'gateway' || type == 'gateway_drp') &&
                            <Grid container spacing={2} mt={1}>                           
                                    <Grid item xs={6}>
                                        <TextField label='Dominio' disabled={update} value={contentModal['domain']} color='secondary' fullWidth size="small" onChange={changeValueModal.bind(this, 'domain')}/>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextField label='URI' disabled={update} value={contentModal['gateway_uri']} color='secondary' fullWidth size="small" onChange={changeValueModal.bind(this, 'gateway_uri')}/>
                                    </Grid>
                            
                                    <Grid item xs={12}>
                                        <TextField label='Endpoint' value={contentModal['endpoint']} color='secondary' fullWidth size="small" onChange={changeValueModal.bind(this, 'endpoint')}/>
                                    </Grid>
                                
                                    <Grid item xs={12}>
                                        <FormControl color='secondary' fullWidth size="small">
                                            <InputLabel htmlFor='form-app'>App</InputLabel>
                                            <Select 
                                                labelId='form-app' 
                                                id='select-app' 
                                                value={contentModal['apps'] || ''} 
                                                label='App'
                                                multiple
                                                onChange={changeValueModal.bind(this, 'apps')}
                                                renderValue={(selected) => (
                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                        {selected.map((value) => (
                                                            <Chip key={value} label={value} />
                                                        ))}
                                                    </Box>
                                                )}
                                            >
                                                {
                                                    apps.map((item, index) => {
                                                        return <MenuItem value={item.name} key={`value-${index}-check`}>{item.name}</MenuItem>
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    {
                                        !contentModal['id'] &&
                                        <Grid container item xs={12} sx={{marginTop: '2%'}}>
                                            <Grid item xs={12}>
                                                <FormControlLabel
                                                    color='secondary'
                                                    control={
                                                        <Checkbox color='secondary' checked={checked} onChange={changeCheck.bind(this)} />
                                                    }
                                                    label='drp'
                                                />
                                            </Grid>
                                        </Grid>
                                    }
                            </Grid>
                        }
                        {
                            (type == 'sidecar' || type == 'sidecar_drp') &&
                            <Grid container pt={1}>
                                <Grid container item xs={12} >
                                    <Grid item xs={12}>
                                        <TextField label='Topic' value={contentModal['topic']} color='secondary' size='small' fullWidth onChange={changeValueModal.bind(this, 'topic')}/>
                                    </Grid>
                                </Grid>
                                {
                                    !contentModal['id'] &&
                                    <Grid container item xs={12} mt={1} mb={1}>
                                        <Grid item xs={12}>
                                            <FormControlLabel
                                                color='secondary'
                                                control={
                                                    <Checkbox color='secondary' checked={checked} onChange={changeCheck.bind(this)} />
                                                }
                                                label='drp'
                                            />
                                        </Grid>
                                    </Grid>
                                }
                                <Grid container item spacing={2} xs={12} sx={{ overflowY: 'auto'}} mt={contentModal['id'] && 2}>
                                    {
                                        contentModal.subscriptions && contentModal.subscriptions.map((item, index) => {
                                            return <Accordion key={`accordion-form-${index}`} sx={{width: '100%'}}>
                                                <AccordionSummary sx={{alignItems: 'center', margin: 0, padding: 0}} expandIcon={<ExpandMore/>}>
                                                    <IconButton title='Eliminar' onClick={deleteSubscription.bind(this, index)}><Close/></IconButton>
                                                    <Typography fontWeight="600" fontFamily="Muli,sans-serif" color="#3E3E42" fontSize="0.875rem" component={'span'} m={0} p={0}>
                                                        Suscripción {index + 1}
                                                    </Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Grid container spacing={2} >
                                                        <Grid item xs={6}>
                                                            <TextField label='Nombre' value={item['name']} color='secondary' size='small' fullWidth onChange={changeValueSubs.bind(this, 'name', index)}/>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <TextField label='Endpoint' value={item['endpoint']} color='secondary' size='small' fullWidth onChange={changeValueSubs.bind(this, 'endpoint', index)}/>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <TextField type='number' label='Tamaño en batch' value={item['batchSize']} color='secondary' size='small' fullWidth onChange={changeValueSubs.bind(this, 'batchSize', index)}/>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <TextField type='number' label='Tiempo de espera' value={item['ackTimeoutSeconds']} color='secondary' size='small' fullWidth onChange={changeValueSubs.bind(this, 'ackTimeoutSeconds', index)}/>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <TextField type='number' label='Tiempo de reintento' value={item['retryDelaySeconds']} color='secondary' size='small' fullWidth onChange={changeValueSubs.bind(this, 'retryDelaySeconds', index)}/>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <FormControl size='small' color='secondary' fullWidth>
                                                                <InputLabel htmlFor='input-domain'>
                                                                    Dominio
                                                                </InputLabel>
                                                                <Select labelId='input-domain' id='select-domain' value={item['domain']} label='Dominio' onChange={changeValueSubs.bind(this, 'domain', index)}>
                                                                    <MenuItem value='' disabled>Seleccione un dominio</MenuItem>
                                                                    {
                                                                        domainsConfig.map((item, index) => {
                                                                            return <MenuItem value={item.domain} key={`value-${index}`}>{item.domain}</MenuItem>
                                                                        })
                                                                    }
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <TextField label='Deadletter topic' value={item['deadletter_topic']} color='secondary' size='small' fullWidth onChange={changeValueSubs.bind(this, 'deadletter_topic', index)}/>
                                                        </Grid>
                                                        {
                                                            item['deadletter_topic'] &&
                                                            <Grid item xs={6}>
                                                                <TextField type={'number'} label='Reintentos' value={item['retryLimit']} color='secondary' size='small' fullWidth onChange={changeValueSubs.bind(this, 'retryLimit', index)}/>
                                                            </Grid>
                                                        }
                                                    </Grid>
                                                </AccordionDetails>
                                            </Accordion>
                                        })
                                    }
                                </Grid>
                                <Button color='secondary' id="buttonDelete" variant='contained' onClick={addSubscription.bind(this)} sx={{textTransform: 'none'}}>Agregar</Button>
                            </Grid>
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button color='secondary' variant='contained' disabled={disabled} onClick={createEdit.bind(this)} sx={{textTransform: 'none'}}>Aceptar</Button>
                    </DialogActions>
                </ModalStyle>
            </Dialog>
        </Grid>
    )
}

export default Management;